import { Location, Transforms } from 'slate';
import { insertVoidElement } from '../../lib/commands';
import { AulaEditorInstance } from '../../types';
import { oneDriveType } from './oneDriveType';
import {
  OneDriveGlobal,
  OneDriveFileInfo,
  OneDrivePickerResult,
} from './types';

// Azure (public) Registered Application ID
const clientId = '13b46b43-3e84-4ade-b528-1f5b13fc6b02';

declare const OneDrive: OneDriveGlobal;

const insertOneDriveFileBlock = (
  file: OneDriveFileInfo,
  editor: AulaEditorInstance,
  location: Location
) => {
  // insert at the end of current block
  Transforms.select(editor, location);

  insertVoidElement(editor, {
    type: oneDriveType,
    viewUrl: file.viewUrl,
    downloadUrl: file.downloadUrl,
    title: file.name,
  });
};

const insertOneDriveErrorBlock = (
  editor: AulaEditorInstance,
  location: Location
) => {
  Transforms.select(editor, location);

  insertVoidElement(editor, {
    type: oneDriveType,

    // Used to notify isPersistable this block cannot be...persisted:
    failed: true,
  });
};

export const openOneDrivePicker = (
  editor: AulaEditorInstance,
  location: Location,
  driveType?: string
) => {
  OneDrive.open({
    clientId,
    action: 'share',
    viewType: 'files',
    multiSelect: true,
    openInNewWindow: true,
    advanced: {
      createLinkParameters: {
        // https://docs.microsoft.com/en-us/onedrive/developer/rest-api/api/driveitem_createlink?view=odsp-graph-online
        // Changing this to 'embed' will return...an embeddable link (only for OneDrive personal)
        type: 'view',
        // https://docs.microsoft.com/en-us/onedrive/developer/rest-api/api/driveitem_createlink?view=odsp-graph-online#scope-types
        // This is required for OneDrive Business accounts so that anyone signed into the organization can use the link to get access.
        ...(driveType === 'business' && { scope: 'organization' }),
      },
      redirectUri: window.location.origin,
    },

    // Will be called by the OneDrive SDK if we experience some type of internal error:
    error: (error: Error) => {
      // eslint-disable-next-line no-console
      console.error('OneDrive Picker API error', error);
      insertOneDriveErrorBlock(editor, location);
    },

    success: (response: OneDrivePickerResult) => {
      const files = response.value;

      if (files.length) {
        files.forEach((file) => {
          const fileInfo: OneDriveFileInfo = {
            source: 'onedrive',
            name: file.name,
            viewUrl: file.webUrl,
            downloadUrl: file['@microsoft.graph.downloadUrl'],
            type: file.file.mimeType,
          };

          insertOneDriveFileBlock(fileInfo, editor, location);
        });
      }
    },
  });
};
